export default {
  warn: function warn(message) {
    return typeof console !== 'undefined' && console.warn && console.warn('[redux-inputs]: ' + message);
  },
  error: function error(message) {
    return typeof console !== 'undefined' && console && console.error && console.error('[redux-inputs]: ' + message);
  }
};